import { Resources } from 'constants/resources';

import { skipToken, useQuery } from '@tanstack/react-query';
import { getMerchantCredentialsJson } from 'config/requests/merchants';

export function useMerchantCredentialsJson(id: string | undefined, enabled = true) {
  const {
    data: credentials,
    isLoading,
    isError,
  } = useQuery({
    queryKey: [`${Resources.MerchantCredentials}/show`, id],
    queryFn: id && enabled ? () => getMerchantCredentialsJson(id) : skipToken,
    retry: false,
    gcTime: 0,
    refetchOnWindowFocus: false,
  });

  return { credentials, isLoading, isError };
}
